import type { OutcomeParameterValue } from '../../../types';
import type { GlobalFilterOverrides, Filter } from '../types';

export const getActiveValueWithOverride = (
    filter: Filter,
    globalFilterOverrides: GlobalFilterOverrides
): OutcomeParameterValue | undefined => {
    let activeValue = filter.activeValue.value;

    const override = globalFilterOverrides[filter.kind];
    if (override) {
        activeValue = override;
    }

    return activeValue;
}
